import {RuleType, CustomValidator, SchemaValidationValue} from '../types'

export const validation =
  (fn: CustomValidator) =>
  (Rule: RuleType): SchemaValidationValue =>
    Rule.custom(fn)
